export default "__VITE_ASSET__CKnLbOSO__"